import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error('[ErrorBoundary] Caught error:', error, info);
    }

    reset() {
        this.setState({ hasError: false, error: null });
    }

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }

            const name = this.props.name;
            const reset = () => this.reset();

            return (
                <div className="flex flex-col items-center justify-center p-8 bg-base-200 rounded-2xl gap-4 text-center">
                    <span className="text-4xl">♟️</span>
                    <h2 className="text-lg font-bold text-base-content">
                        Something went wrong{name ? ` in ${name}` : ''}
                    </h2>
                    <p className="text-base-content/50 text-sm">An unexpected error occurred.</p>
                    <button className="btn btn-primary btn-sm" onClick={reset}>Try Again</button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
